import React, { useEffect } from "react";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateConfigurationFileBreadcrumb } from "../../../redux/configurationFiles/configurationFilesSlice";
// COMPONENTS
import ConfigurationFilesHeader from "./ConfigurationFilesHeader";
import ConfigurationFilesTable from "./ConfigurationFilesTable";
import ConfigurationFilesDrawer from "./ConfigurationFilesDrawer";
import ConfigurationFilesDeleteModal from "./ConfigurationFilesDeleteModal";
import ConfigurationFilesCreateEditForm from "./ConfigurationFilesCreateEditForm";
import ConfigurationFilesDataBlockForm from "./ConfigurationFilesDataBlockForm";
import OffsetsDownloadConfiguration from "../offsets/OffsetsDownloadConfiguration";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const ConfigurationFilesPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    dispatch(updateConfigurationFileBreadcrumb([]));
  }, []);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewEdgeManagementCatalog, permissionSet ?? []) ? (
        <div>
          {/** HEADER AND STEPER */}
          <div className={`layout__contentPage__${theme}`}>
            <ConfigurationFilesDrawer />
            <ConfigurationFilesCreateEditForm />
            <ConfigurationFilesDeleteModal />
            <ConfigurationFilesHeader />
            <ConfigurationFilesTable />
            <ConfigurationFilesDataBlockForm />
            <OffsetsDownloadConfiguration />
          </div>
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default ConfigurationFilesPage;
